export default import.meta.ROLLUP_FILE_URL_AZnlOfd5dAwvnrk6YzP3Tw